import { initContract } from "@ts-rest/core";
import z from "zod";

import { insertPatientShortCodesSchema } from "@libs/db-schemas";

import { HTTPStatusCode } from "../../types";
import { errorSchema } from "../../utils/errors";

const c = initContract();

export const patientsShortCodesContract = c.router({
  assignPatientShortCodeData: {
    summary: "Create a relation with patient and a short code",
    method: "POST",
    path: "/patient-short-codes",
    responses: {
      [HTTPStatusCode.OK]: z.object({
        shortCode: z.string(),
      }),
      [HTTPStatusCode.CREATED]: z.object({
        shortCode: z.string(),
      }),
      [HTTPStatusCode.BAD_REQUEST]: errorSchema,
      [HTTPStatusCode.INTERNAL_SERVER_ERROR]: errorSchema,
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
    },
    // Allow empty string so the handler can treat it as a no-op (no short code to assign)
    body: insertPatientShortCodesSchema.omit({ patientId: true }).extend({
      shortCode: z.string(),
    }),
  },
});
